module.exports = __webpack_public_path__ + "img/logo_h.6359ec32.png";